var g = Object.defineProperty;
var o = (s, t, e) => t in s ? g(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var r = (s, t, e) => o(s, typeof t != "symbol" ? t + "" : t, e);
import { HttpClient as p, httpClient as n } from "../../httpClient.js";
class d extends p {
  constructor() {
    super(...arguments);
    r(this, "endpoint", "/degrees");
  }
  async get(e) {
    return n.get(`${this.endpoint}/${e}`);
  }
  async getAll() {
    return n.get(this.endpoint);
  }
  async getCourses(e) {
    return n.get(`${this.endpoint}/${e}/courses`);
  }
  async switchStudentDegree(e, i) {
    return n.post(`/users/${e}/switch-degree`, {
      toDegreeId: i
    });
  }
}
const a = new d();
export {
  a as default
};
